/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CaretContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_viewer">;
    readonly " $refType": "CaretContainer_viewer";
};
export type CaretContainer_viewer$data = CaretContainer_viewer;
export type CaretContainer_viewer$key = {
    readonly " $data"?: CaretContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CaretContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationDropdownContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '6f9070f53de7070584aded1ef13722d1';
export default node;
